import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Customer } from '../../models/customer';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { ValidationHelpers } from '../../services/validation-helpers';
import { I18N } from 'aurelia-i18n';
import { BasePage } from '../base-page';
import { EventAggregator } from 'aurelia-event-aggregator';
import { Bucket } from '../../models/bucket';
import { ValidationController, ValidationControllerFactory } from 'aurelia-validation';

@autoinject
export class ForgotPassword extends BasePage {
	model: any;
	buttonLabel: any;
	validationErrors: any;
	callingApi: any;
	isAccountLocked: any;
	customerServicePhone: any;
	customerAccountNumberComponent: any;
	zipCode: string;
	registrationId: string;
	registrationIdTwo: string;
	registrationIdThree: string;
	i18n: any;
	validationController: ValidationController;

	constructor(private router: Router, private payrazr: PayrazrService, private globalState: State, i18n: I18N, eventAggregator: EventAggregator,
		validationControllerFactory: ValidationControllerFactory) {
		super(eventAggregator);
		this.validationController = validationControllerFactory.createForCurrentScope();
		this.i18n = i18n.i18next;
		this.model = new Model();
		this.buttonLabel = this.i18n.t('lookMeUp','Look me up');
		this.validationErrors = [];
		this.callingApi = false;
		this.isAccountLocked = false;
	}

	activate() {
		this.customerServicePhone = this.globalState.business.portalSettings.csPhone;
	}

	attached() {
		super.attached();
	}
	public loadTranslations() {
		this.zipCode = this.i18n.t('zipCode', 'Zip Code');
		this.registrationId = this.i18n.t('registrationId', 'Registration ID');
		this.registrationIdTwo = this.i18n.t('registrationIdTwo', 'Registration ID 2');
		this.registrationIdThree = this.i18n.t('registrationIdThree', 'Registration ID 3');
	}
	submit() {
		this.callingApi = true;
		this.validationErrors = [];
		let validator = new Validator(this.i18n);

		if (validator.hasErrors(this.model, this.customerAccountNumberComponent, this.globalState.business.portalSettings)) {
			this.validationErrors = validator.errors;
			this.callingApi = false;
		} else {
			if (!this.model.username) {
				var fields = {
					customerAccountReferenceId: this.model.accountNumber,
					registrationId: this.model.registrationId,
					registrationId2: this.model.registrationId2,
					registrationId3: this.model.registrationId3,
					zipCode: this.model.zipCode,
					bucketKey: this.model.bucket.bucketKey
				};

				this.payrazr.getCustomerSecurityQuestion(fields)
					.then((response: any) => {
						this.model.customerId = response.customerId;
						this.model.username = response.username;
						this.model.securityQuestion = response.securityQuestion;

						this.buttonLabel = this.i18n.t('submitAnswer','Submit answer');
						this.callingApi = false;
					})
					.catch(error => {
						this.validationErrors.push(error);
						this.callingApi = false;
					});
			} else if (!this.model.allowNewPassword) {
				this.payrazr.checkAnswerToSecurityQuestion(this.model.customerId, this.model.securityQuestion, this.model.securityAnswer)
					.then(response => {
						if (response.isSuccessful) {
							this.model.allowNewPassword = true;
							this.buttonLabel = this.i18n.t('requestPasswordReset','Request password reset');
						}
						else {
							if (response.message === 'AccountLocked') {
								this.isAccountLocked = true;
								this.validationErrors.push(this.i18n.t('userAccountLockedContactToUnlock', { defaultValue: `This user account has been locked. Please contact us at ${this.customerServicePhone} to unlock this account or try again later.`, phoneNumber: this.customerServicePhone }))
							}
							else {
								this.validationErrors.push(this.i18n.t('notCorrectAnswer','That is not the correct answer.'));
							}
						}

						this.callingApi = false;
					})
					.catch(() => {
						this.validationErrors.push(this.i18n.t('notCorrectAnswer','That is not the correct answer'));
						this.callingApi = false;
					});
			} else {
				this.payrazr.resetForgottenPassword(this.model.customerId, this.model.username, this.model.securityQuestion, this.model.securityAnswer, this.model.newPassword)
					.then((response: any) => {
						this.router.navigateToRoute('login');
						this.callingApi = false;
					})
					.catch(error => {
						this.model.newPassword = '';
						this.model.confirmPassword = '';
						this.validationErrors.push(error);
						this.callingApi = false;
					});
			}
		}
	}

	cancel() {
		this.router.navigateToRoute('login');
	}
}

class Model {
	accountNumber: any = '';
	registrationId: any = '';
	registrationId2: any = '';
	registrationId3: any = '';
	zipCode: any = '';

	username: any = '';
	securityQuestion: any = '';
	securityAnswer: any = '';

	allowNewPassword: any = '';
	newPassword: any = '';
	confirmPassword: any = '';

	customerId: any = '';

	bucket: Bucket = null;

	constructor() {
	}
}

class Validator {
	errors: any;
	i18n: any;
	constructor(i18next:any) {
		this.errors = [];
		this.i18n = i18next;
	}

	hasErrors(model, customerAccountNumberComponent, portalSettings) {

		if (portalSettings.accountNumberSettings[0].required) {
			customerAccountNumberComponent.validate(this.errors);
		}

		if (portalSettings.registrationIdSettings.required) {
			if (model.registrationId.length === 0) {
				let label = '';
				if (portalSettings.registrationIdSettings.label) label = portalSettings.registrationIdSettings.label;
				else label = this.i18n.t('registrationId', 'Registration Id');
				this.errors.push(this.i18n.t('pleaseEnterYour', { defaultValue: 'Please enter your ' + label, label: label }));
			}
		}

		if (portalSettings.registrationId2Settings.required) {
			if (model.registrationId2.length === 0) {
				let label = '';
				if (portalSettings.registrationId2Settings.label) label = portalSettings.registrationId2Settings.label;
				else label = this.i18n.t('registrationIdTwo', 'Registration Id 2');
				this.errors.push(this.i18n.t('pleaseEnterYour', { defaultValue: 'Please enter your ' + label, label: label }));
			}
		}

		if (portalSettings.registrationId3Settings.required) {
			if (model.registrationId3.length === 0) {
				let label = '';
				if (portalSettings.registrationId3Settings.label) label = portalSettings.registrationId3Settings.label;
				else label = this.i18n.t('registrationIdThree', 'Registration Id 3');
				this.errors.push(this.i18n.t('pleaseEnterYour', { defaultValue: 'Please enter your ' + label, label: label }));
			}
		}

		if (portalSettings.zipcodeSettings.required) {
			if (model.zipCode.length === 0) {
				this.errors.push(this.i18n.t('enterZipCode', 'Please enter your zip code'));
			} else if (!ValidationHelpers.isZipCode(model.zipCode)) {
				this.errors.push(this.i18n.t('enterValidFiveOrNineDigitZipCode', 'Please enter a valid 5 or 9 digit zip code'));
			}
		}

		if (model.username) {
			if (model.securityAnswer.length === 0) {
				this.addError(this.i18n.t('answerSecurityQuestion','Please answer the security question'));
			}

			if (model.allowNewPassword) {
				if (model.newPassword.length < 8 || model.newPassword.length > 50) {
					this.errors.push(this.i18n.t('passwordsMustBeBetweenEightAndFiftyCharacters', 'Passwords must be between 8 and 50 characters.'));
				} else if (!ValidationHelpers.isStrongPassword(model.newPassword)) {
					this.errors.push(this.i18n.t('passwordDoesNotMeetRequirements','Password does not meet requirements'));
				}

				if (model.newPassword !== model.confirmPassword) {
					this.errors.push(this.i18n.t('passwordsDoNotMatch', 'The passwords do not match.'));
				}
			}
		}

		return this.errors.length > 0;
	}

	addError(e) {
		this.errors.push(e);
	}
}
